export function transformTileCanvas(
  source: HTMLImageElement | HTMLCanvasElement,
  sourceWidth: number,
  sourceHeight: number,
  flipHorizontal: boolean,
  flipVertical: boolean,
  flipDiagonal: boolean,
): HTMLCanvasElement {
  const width = flipDiagonal ? sourceHeight : sourceWidth;
  const height = flipDiagonal ? sourceWidth : sourceHeight;
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Could not create a flipped terrain tile");
  context.imageSmoothingEnabled = false;

  const sourceCanvas = document.createElement("canvas");
  sourceCanvas.width = sourceWidth;
  sourceCanvas.height = sourceHeight;
  const sourceContext = sourceCanvas.getContext("2d");
  if (!sourceContext) throw new Error("Could not create a terrain tile source");
  sourceContext.imageSmoothingEnabled = false;
  sourceContext.drawImage(source, 0, 0, sourceWidth, sourceHeight);
  const pixels = sourceContext.getImageData(0, 0, sourceWidth, sourceHeight);
  const transformed = context.createImageData(width, height);

  for (let y = 0; y < sourceHeight; y += 1)
    for (let x = 0; x < sourceWidth; x += 1) {
      let targetX = flipDiagonal ? y : x;
      let targetY = flipDiagonal ? x : y;
      if (flipHorizontal) targetX = width - 1 - targetX;
      if (flipVertical) targetY = height - 1 - targetY;
      const sourceOffset = (y * sourceWidth + x) * 4;
      const targetOffset = (targetY * width + targetX) * 4;
      transformed.data.set(
        pixels.data.subarray(sourceOffset, sourceOffset + 4),
        targetOffset,
      );
    }

  context.putImageData(transformed, 0, 0);
  return canvas;
}
